const PRIORITY_TASK_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
  menuCurationTasks: {},
  menuCurationTasksError: undefined,
  areMenuCurationTasksLoading: false,
  activeTasks: [],
  userAllocationCounts: [],
  userAllocationCountsError: undefined,
  isUserAllocationCountsLoading: false,
  isActiveTaskLoading: false,
  activeTaskError: undefined,
  isUpdateLoading: false,
  updateError: undefined,
  priorityTaskMenuAllocationCounts: undefined,
  isPriorityTaskMenuAllocationCountsLoading: false,
  priorityTaskMenuAllocationCountsError: undefined,
  deletePriorityTaskAllocationError: undefined,
  isDeletePriorityTaskAllocationLoading: false,
  brandsWithNoTop200Menu: [],
  brandsWithNoTop200MenuError: undefined,
  isBrandsWithNoTop200MenuLoading: false,
}

export default PRIORITY_TASK_INITIAL_STATE
